
import React from "react";
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../config/api-config.js';

//import Fetch API functions
import { getContrat, getPaiement } from '../../../database/fetchApi.js'

//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";

//Translate utils :
import { translator } from "../../../utils/translator.js"
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


function Success() { // component to manage the first step of shopping : choosing place and time
    const { refContrat, id_contrat } = useParams(); //id of the selected house, in url (as string)

    let [contrat, setContrat] = useState([]);
    let [paiement, setPaiement] = useState([]);
    const lang = useSelector(getLang) //global state : language
    let modifSuccess = true;

    useEffect(() => { //

        async function initContrat() { //we add this inner function to manage asynchrone
            let contrat = await getContrat(refContrat);
            setContrat(contrat[0]);
            initPaiement(); //call the inner asnchrone function 
        } //end of async function
        initContrat(); //call the inner asnchrone function

        async function initPaiement() { //we add this inner function to manage asynchrone
            let paiement = await getPaiement(/* refContrat */contrat.id_contrat);
            setPaiement(paiement[0]);
        } //end of async function


    }, [])



    if (parseInt(id_contrat) === contrat.id_contrat) { //check the second param is ok to prevent hacking
        window.localStorage.setItem("axepta_resp", contrat.id_contrat);
        console.log(contrat.id_contrat)
        console.log(id_contrat)
    }

    if (paiement && contrat) { //ref ok

        if (paiement.paye === 1 && contrat.paye === 0) { // bug correction : paiement ok but contrat not updated
            modifSuccess = false;
            regulContrat();
        }
    }


    function regulContrat() {
        //console.log("contrat à régule ref", contrat.ref_contrat)
        axios.put(`${baseURL}/contrat/${contrat.id_contrat}`, {
            solde: 0,
            paye: 1
        })
            .then((response) => {
                if (response.status === 200) { //update OK
                    modifSuccess = true;
                }
                else { //insertion problème
                    return response.status
                }
            })
            .catch(error => {
                return error
            })
    }



    return (

        <main>
            <HeaderStep step={6} title={"Paiement confirmé"} custom={""} />

            <div className="payment-success">
                <div className="payment-success-top">
                    <h3>{translator("C'est tout bon!", lang, "orderOk1")}</h3>
                    <p>{translator("Votre paiement a bien été reçu et votre réservation est validée. Merci pour votre confiance :-)", lang, "orderOk2")}</p>
                    <p>{`${translator("Votre numéro de réservation :", lang, "orderOk3")} ${refContrat}`}</p>
                </div>
                <div className="payment-success-middle">
                    <p>
                        {translator("Vous allez recevoir un mail avec un rappel de toutes vos informations pour cette réservation.\nCe mail fera également office de contrat de location.", lang, "orderOk4")}
                    </p>
                </div>
                <div className="payment-success-bottom">

                    <p>Venez découvrir nos autres activités sur notre site <a href="https://www.moutchicinn.com">moutchicinn.com</a></p>
                </div>

            </div>

        </main>

    )
}




export default Success